import { useEffect, useState } from 'react';
import { LaborCategory } from '../../types/pmTypes';
import { CustomModal } from '../CustomModal';
import { Btn } from '../ui';

interface DeleteLaborRateModalProps {
    category: LaborCategory | null;
    isDeleting: boolean;
    onDismiss: () => void;
    onConfirmDelete: () => void;
}

export const DeleteLaborRateModal = ({
    category,
    isDeleting,
    onDismiss,
    onConfirmDelete,
}: DeleteLaborRateModalProps) => {
    const visible = Boolean(category?.id);
    const [confirmReady, setConfirmReady] = useState(false);

    // Avoid click-through from the trash icon activating Delete as the modal opens.
    useEffect(() => {
        if (!visible) {
            setConfirmReady(false);
            return;
        }
        setConfirmReady(false);
        const timer = window.setTimeout(() => setConfirmReady(true), 400);
        return () => window.clearTimeout(timer);
    }, [visible, category?.id]);

    const categoryName = category?.name?.trim() || 'this labor rate';

    return (
        <CustomModal
            onDismiss={onDismiss}
            visible={visible}
            header="Remove labor rate?"
            footer={
                <div className="modal-footer-actions">
                    <Btn
                        variant="secondary-outlined"
                        buttonText="Cancel"
                        buttonDisabled={isDeleting}
                        buttonOnClick={onDismiss}
                    />
                    <Btn
                        variant="danger"
                        buttonText={isDeleting ? 'Removing...' : 'Remove'}
                        buttonDisabled={isDeleting || !confirmReady}
                        buttonOnClick={onConfirmDelete}
                    />
                </div>
            }
        >
            <p>
                You are about to remove <strong>“{categoryName}”</strong>. This will deactivate the labor category.
            </p>
        </CustomModal>
    );
};
